import { FilterListItem } from 'src/models/filterList';
import { ActivityListTypeEnum } from 'src/models/genericActivityList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { FilterListCallbackStoreContract } from '../interfaces';

export class GetAllGlobalFilteredItemsQueryCallBack extends Callback<FilterListItem[]> {
	public constructor(
		private readonly store: FilterListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: FilterListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.FILTER, this.queryIdentifier)) {
			return;
		}

		this.store.setFilterList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
